import { useCallback } from "react";
/**
 * handles navigating between different documents using keyboard arrows
 *
 * @param {*} { _iframe, onPdfReady }
 * @returns
 */
const usePdfArrowNavigation = ({ iframe, onPdfReady }) => {
    // handle onPrev/onNext
    const onKeyDown = useCallback(
        (e: SyntheticKeyboardEvent<*>) => {
            const allowNav =
                e.keyCode === 27 ||
                !iframe.current.contentWindow.PDFViewerApplication.pdfViewer
                    .isHorizontalScrollbarEnabled;

            /* istanbul ignore next */
            if (!allowNav) return;

            switch (e.keyCode) {
                case 27: //Escape - close
                case 39: // right
                case 37: // left
                    var event = document.createEvent("Event");
                    event.initEvent("keydown", true, true);
                    event.keyCode = e.keyCode;
                    document.dispatchEvent(event);
                    break;
                /* istanbul ignore next */
                default:
                    break;
            }
        },
        [iframe]
    );

    // once iframe loads register our events
    const onLoad = useCallback(() => {
        /* istanbul ignore else */
        if (iframe.current != null) {
            iframe.current.contentWindow.addEventListener("keydown", onKeyDown);
            iframe.current.contentWindow.document.addEventListener(
                "textlayerrendered",
                onPdfReady,
                true
            );
        }
    }, [iframe, onPdfReady, onKeyDown]);

    return { onLoad };
};

export default usePdfArrowNavigation;
